export default {
    userStories: {
        title: '1011 故事收集',
        count: '共 {count} 条故事',
        expand: '展开',
        collapse: '收起',
        noImage: '无',
        empty: {
            title: '暂无故事',
            desc: '还没有用户提交 1011 故事，等待用户从任务页提交',
        },
        columns: {
            uid: 'UID',
            content: '故事内容',
            image: '图片',
            submittedAt: '提交时间',
        },
    },
};
